<ng-template #content let-modal>
  <div class="cookies-modal-v3__header">
    <h2 class="cookies-modal-v3__title" id="modal-basic-title">
      {{ "shared-components.gpdr.pop-up-title" | translate }}
    </h2>
    <button
      type="button"
      class="cookies-modal-v3__close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="cookies-modal-v3__body">
    <p
      class="cookies-modal-v3__description"
      [innerHTML]="'shared-components.gpdr.pop-up-description' | translate"
    ></p>

    <ul class="cookies-modal-v3__list">
      <li
        class="cookies-modal-v3__item"
        *ngFor="let cookie of cookies; index as idx"
      >
        <p class="cookies-modal-v3__item-name">
          {{ cookie.title }}
          <span *ngIf="!cookie.isOptional">
            <sup
              class="cookies-modal-v3__required-icon"
              [title]="'shared-components.gpdr.required-cookie' | translate"
              >📄</sup
            >
          </span>
        </p>
        <app-toggle-switch
          *ngIf="cookie.isOptional"
          [active]="cookie.status"
          (click)="toggleCookieHandler(cookie.id, idx)"
        ></app-toggle-switch>
      </li>
    </ul>

    <a
      class="cookies-modal-v3__policy-link"
      href="https://noliaedu.com/cookies"
      target="_blank"
    >
      {{ "shared-components.gpdr.cookies-policy-link" | translate }}
    </a>
  </div>

  <div class="cookies-modal-v3__footer">
    <button
      type="button"
      class="cookies-modal-v3__text-btn"
      (click)="disableAllCookies()"
    >
      {{ "shared-components.gpdr.disable-all" | translate }}
    </button>
    <button
      type="button"
      class="cookies-modal-v3__text-btn"
      (click)="enableAllCookies()"
    >
      {{ "shared-components.gpdr.accept-all" | translate }}
    </button>
    <button type="button" class="cookies-modal-v3__save-btn" (click)="save()">
      {{ "shared-components.gpdr.save-button" | translate }}
    </button>
  </div>
</ng-template>
<div class="cookies-v3" [class.cookies-v3--show]="gpdrBlock">
  <div class="cookies-v3__content">
    <p class="cookies-v3__text">
      {{ "shared-components.gpdr.cookies-banner" | translate }}
      <a
        href="https://noliaedu.com/terminos"
        target="_blank"
        class="cookies-v3__link"
      >{{ "shared-components.gpdr.terms-and-conditions-label" | translate }}</a>
      {{ "shared-components.gpdr.and" | translate }}
      <a
        href="https://noliaedu.com/privacidad"
        target="_blank"
        class="cookies-v3__link"
      >{{ "shared-components.gpdr.privacy-policy" | translate }}</a>.
    </p>
    <div class="cookies-v3__actions">
      <button
        type="button"
        class="cookies-v3__btn cookies-v3__btn--ghost"
        (click)="open(content)"
      >
        {{ "shared-components.gpdr.manage-cookies" | translate }}
      </button>
      <button
        type="button"
        class="cookies-v3__btn cookies-v3__btn--primary"
        (click)="toggleGpdrBlock()"
      >
        {{ "shared-components.gpdr.understood-button" | translate }}
      </button>
    </div>
  </div>
</div>
